module.exports = __webpack_public_path__ + "dist/img/bonus-bag.a696d1b0.png";